import { DdpCta } from "@/components/shared/DdpCta";
import { HomeImgMarquee } from "./home-img-marquee";
import { THomeProps } from "../type";
import { useCmsStore } from "@/components/AppHooks";
import { SingleImg } from "@/components/shared/SingleImg";
import { IconArrow } from "@/components/icon/master";
import { SimnoffTopMarquee } from "@/components/shared/Smirnoff/TopMarquee";
import { useEffect } from "react";
import { tracking } from "@/shared/tracking";
export function HomeSmirnoff(props: THomeProps) {
    const { title, description, cTA } = props
    const { localeData } = useCmsStore()!
    // useEffect(() => {
    //     tracking({
    //         "event": "custom_event",
    //         "event_name": "quiz_start"
    //     })
    // }, [])
    return <div className="page-smirnoff-home">
        <SimnoffTopMarquee />
        <div className='top-wrapper smirnoff-page-container'>
            <SingleImg className="top-label" image={localeData.alterTopLabelWhatsYourCocktail} />
            <h1 className='title'>{title}</h1>
            <div className='description' dangerouslySetInnerHTML={{ __html: description }}></div>
            <div className='cta-wrapper sm:hidden  md:flex desk:flex'>
                <DdpCta className='btn-next' cta={cTA} >
                    <IconArrow right />
                </DdpCta>
            </div>
        </div>
        <div className='bottom-wrapper'>
            <div className="w-full">
                <HomeImgMarquee images={props.imageSlide} />
            </div>
        </div>
        <div className='cta-wrapper md:hidden desk:hidden'>
            <DdpCta className='btn-next' cta={cTA} >
                <IconArrow right />
            </DdpCta>
        </div>
    </div>
}